module.exports = __webpack_public_path__ + "fonts/brlnsb.d725100f.ttf";